var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyChooseBulletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F66A3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9125 20.65L18.7938 16H15.7938L16.3375 11.7438L12.8688 16.75H15.475L14.9125 20.65ZM13 23.5L13.75 18.25H10L16.75 8.5H18.25L17.5 14.5H22L14.5 23.5H13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseBulletIcon);
export default __webpack_public_path__ + "static/media/why_choose_bullet_icon.31b461a0c50f80e57e1d8f3931cceb92.svg";
export { ForwardRef as ReactComponent };